import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import 'mapbox-gl/dist/mapbox-gl.css';
import './scss/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

// Import at the top of the file to ensure Sentry is initialized before any other code runs
import setup from './config/setup';
import getAppBasename from 'config/getAppBasename';
// import { GoogleAnalyticsProvider } from './utils/googleAnalytics';
import RetailerGuard from 'components/RetailerGuard';
import { AppProvider } from 'context/AppContext';
import { AuthProvider } from 'context/AuthContext';
import { SegmentProvider } from 'context/SegmentContext';
import { LogRocketProvider } from 'context/LogRocketContext';
import App from './App';

const history = createBrowserHistory({ basename: getAppBasename() });

setup(history);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router history={history}>
    {/* <GoogleAnalyticsProvider> */}
    <AppProvider>
      <AuthProvider>
        <RetailerGuard>
          <LogRocketProvider>
            <SegmentProvider>
              <App />
            </SegmentProvider>
          </LogRocketProvider>
        </RetailerGuard>
      </AuthProvider>
    </AppProvider>
    {/* </GoogleAnalyticsProvider> */}
  </Router>,
);
